import React from 'react';

import PlaceholderTab from '~/components/Offers/Detail/OfferBuilder/shared/PlaceholderTab';

import { PROPERTY_SETUP_FIELDS } from './fields';

export default function PropertySetupTab() {
  return <PlaceholderTab configuredFieldCount={PROPERTY_SETUP_FIELDS.length} title="Property Setup" />;
}
